import { Pipe, PipeTransform } from '@angular/core';
import { SLMovementLineShareType } from './movement';
import { SLMovementLineShareTypePipe } from './movement-line-share-type.pipe';
import { SLSharePipe } from './share.pipe';

function fmtShare(share: string|number) {
  return new SLSharePipe().transform(share);
}

function fmtShareType(shareType: SLMovementLineShareType) {
  return new SLMovementLineShareTypePipe().transform(shareType, 'short');
}

@Pipe({ name: 'slaccountbalanceitems' })
export class SLAccountBalanceItemsPipe implements PipeTransform {
 
  transform(items: any, ...args: any[]) {
    const ownership = args[0];

    const s = [
      {
        value: fmtShare(items[`${ownership}_ORD`]),
        unit: fmtShareType('ORD')
      },
      {
        value: fmtShare(items[`${ownership}_PREF`]),
        unit: fmtShareType('PREF')
      },
      {
        value: fmtShare(items[`${ownership}_BSA`]),
        unit: fmtShareType('BSA')
      },
      {
        value: fmtShare(items[`${ownership}_BSPCE`]),
        unit: fmtShareType('BSPCE')
      },
      {
        value: fmtShare(items[`${ownership}_AGA`]),
        unit: fmtShareType('AGA')
      },
      {
        value: fmtShare(items[`${ownership}_SO`]),
        unit: fmtShareType('SO')
      },
    ].filter(({ value }) => value !== '0')
    .map(({ value, unit })=> `${value} ${unit}`)
    .join('<br>');
  
    if (s.length > 0) {
      return s;
    }
    else {
      return '0';
    }
  }
}
